module.exports = __webpack_public_path__ + "img/29.7d0d9595.jpg";